import React from 'react';

import {
  List,
} from '@mui/material';

import type { MeasureJson } from '@/types/domain/measure/entities/measureEntity';

import CustomListItem from '@/components/CustomListItem';
import { ChestCircumference } from '@/domain/measure/service/entity/valueObjects/chestCircumference';
import { HeadCircumference } from '@/domain/measure/service/entity/valueObjects/headCircumference';
import { Height } from '@/domain/measure/service/entity/valueObjects/height';
import { Weight } from '@/domain/measure/service/entity/valueObjects/weight';

const MeasureInfo: React.FC<{
  /** データ */
  data: MeasureJson,
}> = ({ data }) => {
  const {
    height,
    weight,
    headCircumference,
    chestCircumference,
  } = data.data;
  return (
    <List>
      <CustomListItem
        name={Height.label}
        content={height?.toString() || '-'}
      />
      <CustomListItem
        name={Weight.label}
        content={weight?.toString() || '-'}
      />
      <CustomListItem
        name={HeadCircumference.label}
        content={headCircumference?.toString() || ''}
      />
      <CustomListItem
        name={ChestCircumference.label}
        content={chestCircumference?.toString() || ''}
      />
    </List>
  );
};

export default MeasureInfo;
